import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UTextareaComponent } from './u-textarea.component';
import { InputTextareaModule } from 'primeng/inputtextarea';

@NgModule({
  declarations: [UTextareaComponent],
  imports: [CommonModule, FormsModule, InputTextareaModule, ReactiveFormsModule],
  exports: [UTextareaComponent],
})
export class UTextareaModule {}
